import "./TranscationActivity.css";

import React, { useEffect, useRef, useState } from "react";

import Headers from "Components/Header/Headers";
import MoneyCreditTransactionReceipt from "Components/Popup/MoneyCreditTransactionReceipt/MoneyCreditTransactionReceipt";
import MoneyCreditTransactionReceiptPdf from "Components/Popup/MoneyCreditTransactionReceiptPdf/MoneyCreditTransactionReceiptPdf";
import Navigation from "Components/SideNavBar/Navigation";
import { useReactToPrint } from "react-to-print";
import RefundRequest from "Components/Popup/RefundRequest/RefundRequest";
import StripeOnboardingRequiredPopup from "Components/Popup/StripeOnboardingRequiredPopup/StripeOnboardingRequiredPopup";
import SearchIcon from "@mui/icons-material/Search";
import detailsIcon from "Media/icons/Group 641@2x.png";
import { getTranscationListApi, getUserDetails } from "Config/API/get";
import useStripeOnboardingGuard from "Hooks/useStripeOnboardingGuard";
import { fetchStripeConnectedAccountId } from "Helper/stripeConnectedAccount";
import { isMobile } from "react-device-detect";
import printIcon from "Media/icons/Group 640@2x.png";
import refundIcon from "Media/icons/cashback (1)@2x.png";
import refundIconDisabled from "Media/icons/cashbackDisabled.png";
import useFullPageLoader from "Hooks/useFullPageLoader";
import { useSelector } from "react-redux";

const formatTransactionAmount = (value) => {
  const num = parseFloat(value);
  if (value === undefined || value === null || value === "" || Number.isNaN(num)) {
    return "-";
  }
  return Math.abs(num).toFixed(2);
};

const getGrossAmount = (transaction) => {
  const metadata = transaction?.metadata || {};
  if (metadata.gross_amount_usd || transaction?.netAmount) {
    return formatTransactionAmount(metadata.gross_amount_usd || transaction?.netAmount);
  }
  const net = parseFloat(metadata.net_to_destination_usd || transaction?.credit);
  const fee = parseFloat(metadata.platform_fee_usd || transaction?.processingFees);
  if (!Number.isNaN(net) && !Number.isNaN(fee) && fee > 0) {
    return (Math.abs(net) + fee).toFixed(2);
  }
  return "-";
};
const getProcessingFee = (transaction) => {
  const fee = transaction?.metadata?.platform_fee_usd || transaction?.processingFees;
  if (fee === undefined || fee === null || fee === "" || parseFloat(fee) === 0) {
    return "-";
  }
  return formatTransactionAmount(fee);
};

const TranscationActivity = () => {
  let doneTypingInterval = 1500;
  let typingTimer;
  const token = localStorage.getItem("token");
  const [loader, setLoader, resetLoader] = useFullPageLoader();
  const [transcationList, setTranscationList] = useState("");
  const [filterKeyword, setFilterKeyword] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [receiptDetails, setReceiptDetails] = useState("");
  const [refundRequest, setRefundRequest] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const credit = useSelector((state) => state.getStripeCreditBalanceReducer);
  const { isOnboardingRequired, stripeDashboardUrl } =
    useStripeOnboardingGuard();
  const [showStripeOnboardingPopup, setShowStripeOnboardingPopup] =
    useState(false);
 const componentRef = useRef();
const nullRef = useRef();
const [selectedRef, setSelectedRef] = useState("");

const handlePrint = useReactToPrint({
  contentRef: componentRef,
  onAfterPrint: () => {
    setSelectedRef("");
  },
});

useEffect(() => {
  if (!selectedRef) return;

  const timer = setTimeout(() => {
    handlePrint();
  }, 0);

  return () => clearTimeout(timer);
}, [selectedRef, handlePrint]);
  const adminprofile = useSelector((state) => state.authenticationReducer);
  const generalInfo = useSelector((state) => state.renderGeneralInfo);
  const [account_Id, setAccount_Id] = useState("");
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const fetchUserData = async () => {
      try {
        const apiResponse = await getUserDetails(token);
        if (!cancelled && apiResponse?.data?.status) {
          setUserData(apiResponse.data.data || null);
        }
      } catch (error) {
        console.error("Error fetching user data", error);
      }
    };
    fetchUserData();
    return () => {
      cancelled = true;
    };
  }, [token]);

  useEffect(() => {
    let cancelled = false;
    fetchStripeConnectedAccountId(token, adminprofile, generalInfo).then(
      (accountId) => {
        if (!cancelled) setAccount_Id(accountId || "");
      }
    );
    return () => {
      cancelled = true;
    };
  }, [token, adminprofile, generalInfo]);

  useEffect(() => {
    if (!account_Id) return;
    getTransactionData();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account_Id]);

  useEffect(() => {
    if (!userData?.role) return;
    if (
      isOnboardingRequired &&
      userData.role?.toString()?.toLowerCase() !== "employee"
    ) {
      setShowStripeOnboardingPopup(true);
    }
  }, [isOnboardingRequired, userData?.role]);

  const canManageCreditAccount =
    userData?.credit_account_manager === "manager";

  const getTransactionData = () => {
    setLoader();
    const transcation_status = getTranscationListApi(token, "", "",account_Id);
    transcation_status.then((res) => {
      resetLoader();
      if (res?.status === 200) {
        setTranscationList(res?.data?.data);
      }
    });
  };

  const search_fuction = (value) => {
    const transcation_status = getTranscationListApi(
      token,
      value,
      filterKeyword,
      account_Id
    );
    transcation_status.then((res) => {
      if (res?.status === 200) {
        setTranscationList(res?.data?.data);
      }
    });
  };

  const filter_function = (value) => {
    const transcation_status = getTranscationListApi(
      token,
      searchKeyword,
      value,
      account_Id
    );
    transcation_status.then((res) => {
      if (res?.status === 200) {
        setTranscationList(res?.data?.data);
      }
    });
  };

  const openRefundDialog = (data) => {
    if (!canManageCreditAccount) return;
    setSelectedRowData(data);
    setRefundRequest(true);
  };

  return (
    <>
      <div className="money-credit-transcation-main">
        <div className="money-credit-transcation-main-header">
          <Headers />
        </div>

        <div className="money-credit-transcation-navigation">
          <Navigation />
        </div>
        <div className="money-credit-transcation-wrapper">
          <div className="money-credit-transcation-header">
            Transaction Activity Page
            {canManageCreditAccount && stripeDashboardUrl && (
              <div className="money-credit-transcation-header-actions">
                <button
                  type="button"
                  className="money-credit-transcation-stripe-button"
                  onClick={() => window.open(stripeDashboardUrl, "_blank")}
                >
                  Manage Stripe Account
                </button>
              </div>
            )}
          </div>
          <div className="money-credit-transcation-content">
            <div className="money-credit-transcation-top-part">
              <div className="money-credit-transcation-search">
                <input
                  type="search"
                  placeholder="Search..."
                  onChange={(e) => {
                    clearTimeout(typingTimer);
                    if (e.target.value || e.target.value === "") {
                      typingTimer = setTimeout(() => {
                        search_fuction(e.target.value);
                        setSearchKeyword(e.target.value);
                      }, doneTypingInterval);
                    }
                  }}
                />
                <SearchIcon />
              </div>
              <div className="money-credit-transcation-balance">
                <span>BALANCE </span>
                <b>{credit ? credit : 0}</b>
              </div>
              <div className="money-credit-transcation-filter">
                <p>Filter:</p>
                <select
                  onClick={(e) => {
                    filter_function(e.target.value);
                    setFilterKeyword(e.target.value);
                  }}
                >
                  <option value="">All</option>
                  <option value="Credit">Balance</option>
                  <option value="Debit">Debits</option>
                </select>
              </div>
            </div>
            <div className="money-credit-transcation-bottom-part">
              <div className="money-credit-transcation-head-row-wrapper">
                <div
                  className="money-credit-transcation-head-row"
                  style={{ width: "11%" }}
                >
                  DATE
                </div>
                <div
                  className="money-credit-transcation-head-row"
                  style={{ width: "13%" }}
                >
                  TRANSACTION ID
                </div>
                <div
                  className="money-credit-transcation-head-row"
                  style={{ width: "14%" }}
                >
                  DESCRIPTION
                </div>
                <div
                  className="money-credit-transcation-head-row"
                  style={{ width: "18%" }}
                >
                  TRANSACTION WITH
                </div>
                <div
                  className="money-credit-transcation-head-row"
                  style={{ width: "15%" }}
                >
                  GROSS AMOUNT
                </div>
                <div
                  className="money-credit-transcation-head-row"
                  style={{ width: "15%" }}
                >
                  PROCESSING FEES
                </div>
                <div
                  className="money-credit-transcation-head-row"
                  style={{ width: "8%" }}
                >
                  BALANCE
                </div>
                <div
                  className="money-credit-transcation-head-row"
                  style={{ width: "18%" }}
                >
                  ACTIONS
                </div>
              </div>
              <div className="money-credit-transcation-body-row-scroll">
                {transcationList ? (
                  transcationList.length > 0 ? (
                    transcationList?.map((curr, index) => {
                      const grossAmount = getGrossAmount(curr);
                      const processingFee = getProcessingFee(curr);

                      return (
                        <div
                          className="money-credit-transcation-body-row-wrapper"
                          key={index}
                        >
                          <div
                            className="money-credit-transcation-body-row"
                            style={{ width: "11%" }}
                          >
                            {curr?.dateTime || "-"}
                          </div>
                          <div
                            className="money-credit-transcation-body-row"
                            style={{ width: "13%" }}
                          >
                            {curr?.transactionId || "-"}
                          </div>
                          <div
                            className="money-credit-transcation-body-row"
                            style={{ width: "14%" }}
                          >
                            {curr?.description || "-"}
                          </div>
                          <div
                            className="money-credit-transcation-body-row"
                            style={{ width: "18%" }}
                          >
                            {curr?.transactionWith || "-"}
                          </div>
                          <div
                            className="money-credit-transcation-body-row"
                            style={{ width: "15%" }}
                          >
                            {/* {(grossAmount === "-"||curr?.creditType!=="payment")  ? "-" : `$${grossAmount}`} */}
                              {curr?.grossAmount || "-"}
 
                          </div>
                          <div
                            className="money-credit-transcation-body-row"
                            style={{ width: "15%" }}
                          >
                            {/* {(processingFee === "-"||curr?.creditType!=="payment") ? "-" : `$${processingFee}`} */}
                            {curr?.processingFees || "-"}
                          </div>
                          <div
                            className="money-credit-transcation-body-row"
                            style={{ width: "8%" }}
                          >
                            {curr?.creditType ? (
                              (curr?.creditType?.toString().toLowerCase() === "credit" ||
 curr?.creditType?.toString().toLowerCase() === "payment") ? (
                                <span className="money-credit-transcation-body-credit">
                                  + {curr?.credit || ""}
                                </span>
                              ) : (
                                <span className="money-credit-transcation-body-debit">
                                  - {curr?.credit.replace("-", "") || ""}
                                </span>
                              )
                            ) : (
                              "-"
                            )}
                          </div>
                          <div
                            className="money-credit-transcation-body-row"
                            style={{
                              width: "18%",
                            }}
                          >
                            {curr?.creditType?.toString().toLowerCase() ===
                              "debit" &&
                            curr?.isRefundable === true &&
                            curr?.slug === "Video chat" &&
                            canManageCreditAccount ? (
                              <img
                                src={refundIcon}
                                alt="Refund"
                                onClick={() => openRefundDialog(curr)}
                              />
                            ) : (
                              <img src={refundIconDisabled} alt="Refund" />
                            )}

                            {!isMobile && (
                           <img
  src={printIcon}
  alt="Print"
  onClick={() => setSelectedRef(curr?.transactionId)}
  style={{ cursor: "pointer" }}
/>
                            )}

                            {/* our pdf for each transaction */}
                            <div style={{ display: "none" }}>
                              <div
                                className="print-content-pdf"
                                ref={
                                  selectedRef === curr?.transactionId
                                    ? componentRef
                                    : nullRef
                                }
                              >
                                <MoneyCreditTransactionReceiptPdf
                                  details={curr}
                                />
                              </div>
                            </div>

                            <img
                              src={detailsIcon}
                              alt="Details"
                              onClick={() => {
                                setReceiptDetails(curr);
                              }}
                            />
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div
                      style={{
                        fontFamily: "var(--montserrat)",
                        fontWeight: "bold",
                        textAlign: "center",
                        marginTop: "50px",
                      }}
                    >
                      No transaction Activity found
                    </div>
                  )
                ) : (
                  <div
                    style={{
                      fontFamily: "var(--montserrat)",
                      fontWeight: "bold",
                      textAlign: "center",
                      marginTop: "50px",
                    }}
                  >
                    No transaction Activity found
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* receipt details popup */}
      {receiptDetails && (
        <MoneyCreditTransactionReceipt
          hide={setReceiptDetails}
          details={receiptDetails}
        />
      )}
      {refundRequest && (
        <RefundRequest
          hide={setRefundRequest}
          selectedRowData={selectedRowData}
          getTransactionData={getTransactionData}
        />
      )}
      {showStripeOnboardingPopup && (
        <StripeOnboardingRequiredPopup
          hide={setShowStripeOnboardingPopup}
          dashboardUrl={stripeDashboardUrl}
        />
      )}
      {loader}
    </>
  );
};

export default TranscationActivity;
